import { Route } from "react-router-dom";
import { ProtectedRoute } from "../../routers/protected-route";
import { GivenCansPage, CreateGivenCans, UpdateGivenCans } from "./pages";

export const GivenCansRouter = [
  <Route
    path="/given-cans"
    element={
      <ProtectedRoute roles={["Any"]}>
        <GivenCansPage />
      </ProtectedRoute>
    }
  />,

  <Route path="/given-can">
    <Route
      path="create"
      element={
        <ProtectedRoute roles={["Any"]}>
          <CreateGivenCans />
        </ProtectedRoute>
      }
    />
    <Route
      path=":id/update"
      element={
        <ProtectedRoute roles={["Any"]}>
          <UpdateGivenCans />
        </ProtectedRoute>
      }
    />
  </Route>,
];
